"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineMainFrameHeader = exports.MainFrameHeader = void 0;
const lib_es2015_1 = require("@hodol/webapp-common/lib-es2015");
const lib_es2015_2 = require("@hodol/dom-helper/lib-es2015");
const lib_es2015_3 = require("@hodol/web-component-helper/lib-es2015");
const menu_button_1 = require("./menu-button");
class MainFrameHeader extends HTMLElement {
    constructor() {
        super();
        this.serverProps = (0, lib_es2015_1.getServerProps)();
        this.innerHTML = `
      <menu-button class="menu-btn" color="#444444"></menu-button>
      <div class="member-control">
        <button class="cart">Cart</button>
        <button class="login">Login</button>
        <button class="join">Join</button>
      </div>`;
        this.menuBtn = (0, lib_es2015_2.getQuerySelectOrThrowError)(this, 'menu-button');
        this.menuBtn.addEventListener('click', () => {
            this.dispatchEvent(new CustomEvent('click-menu-btn', {
                bubbles: true,
                cancelable: true,
            }));
        });
    }
}
exports.MainFrameHeader = MainFrameHeader;
const defineMainFrameHeader = (name) => {
    (0, menu_button_1.defineMenuButton)('menu-button');
    (0, lib_es2015_3.defineIfUndefined)(name, MainFrameHeader);
};
exports.defineMainFrameHeader = defineMainFrameHeader;
